module.exports = __webpack_public_path__ + "assets/img/home-swiper-4.10765d00.png";